import React, {ReactElement} from 'react';
import {Container, I18NText, Icon, Modal, Text, useIcons,} from '@yosmanyga/rich-ui';
import {UnnormalizedProps} from '@yosmanyga/core-style';

const Menu = ({
    unread,
    version,
    onClose,
    onNavigateToNotes,
    onNavigateToHelp,
    onNavigateToMap,
    onNavigateToFeedback,
    onNavigateToRestoration,
    onNavigateToRestart,
    onNavigateToBuy,
}: {
    unread: number;
    version: string;
    onClose: () => void;
    onNavigateToNotes: () => void;
    onNavigateToHelp: () => void;
    onNavigateToMap: () => void;
    onNavigateToFeedback: () => void;
    onNavigateToRestoration: () => void;
    onNavigateToRestart: () => void;
    onNavigateToBuy: () => void;
}) => {
    const icons = useIcons();

    return <Modal onClose={onClose}>
        <Container intent="modal_body">
            <MenuButton
                icon={<Icon
                    component={icons.objects.map}
                    size='xs'
                />}
                text="Map"
                subtitle="Track your route"
                onClick={onNavigateToMap}
                margin={{
                    top: 2
                }}
            />

            <MenuButton
                icon={<Icon
                    component={icons.objects.notes}
                    size='xs'
                />}
                text="Notes"
                subtitle="Save your notes"
                onClick={onNavigateToNotes}
                margin={{
                    top: 2
                }}
            />

            <MenuButton
                icon={<Icon
                    component={icons.objects.restoration}
                    size='xs'
                />}
                text="Move back"
                subtitle="Go back in time"
                onClick={onNavigateToRestoration}
                margin={{
                    top: 2
                }}
            />

            <MenuButton
                icon={<Icon
                    component={icons.objects.help}
                    size='xs'
                />}
                text="Help"
                subtitle="Learn the rules"
                onClick={onNavigateToHelp}
                margin={{
                    top: 2
                }}
            />

            <MenuButton
                icon={
                    <>
                        <Icon
                            component={icons.objects.feedback}
                            size='xs'
                        />
                        {unread ? (
                            <Container
                                intent="badge"
                                position={{
                                    type: 'relative',
                                    top: -10,
                                    right: 0,
                                }}
                            >
                                <Text intent="badge">{unread}</Text>
                            </Container>
                        ) : undefined}
                    </>
                }
                text="Feedback"
                subtitle="Get in touch"
                onClick={onNavigateToFeedback}
                margin={{
                    top: 2
                }}
            />

            <MenuButton
                icon={<Icon
                    component={icons.actions.restart}
                    size='xs'
                />}
                text="Restart"
                subtitle="Start again"
                onClick={onNavigateToRestart}
                margin={{
                    top: 2
                }}
            />

            {/*{version !== 'premium' && <MenuButton*/}
            {/*  icon={<Icon*/}
            {/*      component={icons.objects.cart}*/}
            {/*      size='xs'*/}
            {/*  />}*/}
            {/*  text='Premium'*/}
            {/*  subtitle='Buy Premium version'*/}
            {/*  onClick={onNavigateToBuy}*/}
            {/*  margin={{*/}
            {/*    top: 2*/}
            {/*  }}*/}
            {/*/>}*/}

            <Container
                intent='menu_title'
                margin={{
                    top: 4
                }}
            >
                <I18NText
                    intent='secondary'
                >
                    {version === 'trial'
                        ? 'Trial version' : (version === 'basic'
                                ? 'Trial ended'
                                : 'Premium version'
                        )}
                </I18NText>
            </Container>
        </Container>
    </Modal>
};

const MenuButton = ({
    icon,
    text,
    subtitle,
    onClick,
    margin,
    right,
}: {
    icon: ReactElement;
    text: string;
    subtitle: string;
    onClick: () => void;
    right?: boolean;
} & UnnormalizedProps) => {
    return <Container
        intent='button'
        flow="row"
        align={{
            cross: 'center',
        }}
        onClick={onClick}
        margin={{
            ...(typeof margin === 'object' ? margin : {}),
            left: right ? 4 : undefined,
        }}
    >
        {!right && icon}
        <Container
            flow="column"
            align={{
                cross: right ? 'flex-end' : undefined,
            }}
            margin={{
                left: !right ? 1 : undefined,
                right: right ? 1 : undefined,
            }}
        >
            <I18NText>
                {text}
            </I18NText>
            <I18NText intent="secondary">{subtitle}</I18NText>
        </Container>
        {right && icon}
    </Container>
};

export {Menu};
